import { type IdeaCategoryAttributes } from './generated/IdeaCategoryAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface IdeaCategory extends IdeaCategoryAttributes {}

@model
class IdeaCategory extends ApplicationModel {
  // Start auto-generated
  static typename: 'IdeaCategory' = 'IdeaCategory';
  get typename(): 'IdeaCategory' {
    return 'IdeaCategory';
  }

  static internalTypename: 'Ideas::IdeaCategory' = 'Ideas::IdeaCategory';
  get internalTypename(): 'Ideas::IdeaCategory' {
    return 'Ideas::IdeaCategory';
  }

  static filterType = 'IdeaCategoryFilters!';
  static filters = { id: '[ID!]', projectId: 'ID', query: 'String' };

  static fields = {
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    projectId: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    parentCategory: attr.belongsTo({
      readable: true,
      typename: 'IdeaCategory',
    }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    categories: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default IdeaCategory;
